import { render, staticRenderFns } from "./SigninSignoutLink.vue?vue&type=template&id=5a498ef7&"
import script from "./SigninSignoutLink.vue?vue&type=script&lang=js&"
export * from "./SigninSignoutLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports